import React, { useEffect, useRef, useMemo } from "react";
import * as Scrivito from "scrivito";
import { LeftSidebarPortal, ObjValidator, XCircleLoader } from "components";
import { useAppBaseContext } from "providers";
import { useToastCleanup } from "hooks";
import { SideBarWrapper } from "components/LeftSidebar/SideBarWrapper";
import { ProductListLeftSidebar } from "objs/_ConfiguratorObjs/ProductList/ProductListLeftSidebar/ProductListLeftSidebar";
import { ProductsOverview } from "components/ProductsOverview/ProductsOverview";
import {
  useProductsOverviewActions,
  useProductsOverviewStore,
} from "stores/productsOverviewStore";
import { useAuthStore } from "stores/authStore";
import { useAllProducts } from "hooks/productHooks/useAllProducts";

export const ProductList = Scrivito.connect(() => {
  const { lang } = useAppBaseContext();
  const currentUserTenant = useAuthStore.use.currentUser()?.tenant;
  const allProducts = useAllProducts();

  const params = Scrivito.currentPageParams();
  const { shouldKeepProductCategories } = params;

  const {
    getProductsData,
    setProductsContent,
    setCategoryHeadline,
    setProductCategoryId,
  } = useProductsOverviewActions();

  useEffect(() => {
    if (!shouldKeepProductCategories) {
      setProductCategoryId([]);
    }
    if (lang && currentUserTenant) {
      getProductsData({ lang, currentUserTenant });
    }
  }, [
    lang,
    currentUserTenant,
    getProductsData,
    shouldKeepProductCategories,
    setProductCategoryId,
  ]);

  const productCategoryId = useProductsOverviewStore(
    (state) => state.productCategoryId,
  );

  const selectedCategory = useMemo(() => {
    if (!productCategoryId) {
      return [];
    }
    return Array.isArray(productCategoryId)
      ? productCategoryId
      : [productCategoryId];
  }, [productCategoryId]);

  const toastRef = useRef(null);

  useToastCleanup(toastRef);

  useEffect(() => {
    if (selectedCategory?.length === 0) {
      setProductsContent(allProducts);
      setCategoryHeadline("");
    } else {
      const findNodes = (prods = []) =>
        prods?.forEach((item) => {
          if (item.keyList?.join("/") === selectedCategory?.join("/")) {
            setProductsContent(item.nodes);
          }
          findNodes(item.nodes);
        });
      findNodes(allProducts);
    }
  }, [selectedCategory, allProducts, setProductsContent, setCategoryHeadline]);

  return (
    <div className="d-flex flex-grow-1 bg-gray-100 h-full overflow-scroll overflow-x-hidden">
      {!allProducts.length ? (
        <XCircleLoader />
      ) : (
        <>
          <ProductsOverview isModalActive={false} />
          <LeftSidebarPortal>
            <SideBarWrapper classNames="sideBarWidth">
              <ProductListLeftSidebar isModalActive={false} />
            </SideBarWrapper>
          </LeftSidebarPortal>
        </>
      )}
    </div>
  );
});

const CheckedPage = (props) => {
  const { productCategoryId } = Scrivito.currentPageParams();

  return (
    <ObjValidator {...props}>
      <ProductList {...props} {...{ productCategoryId }} />
    </ObjValidator>
  );
};

export default CheckedPage;
Scrivito.provideComponent("ProductList", CheckedPage);
